module.exports = __webpack_public_path__ + "static/img/banner_home01.0a5407f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_home01.png
// module id = OiE9
// module chunks = 15